<div class="flex flex-column">
  <label class="mb-2">{{ 'misc.paramLabel' | transloco: {paramName: 'deviceGateway'} }}</label>
  <input
    (ngModelChange)="updateGateway($event)"
    *ngIf="loaded"
    [ngModel]="deviceGateway"
    [required]="_mode === 'sendCommand'"
    pInputText
  >
  <p-skeleton *ngIf="!loaded" height="33px" styleClass="w-full"></p-skeleton>
</div>
<div class="flex flex-column">
  <label class="mb-2">{{ 'misc.paramLabel' | transloco: {paramName: 'sensorName'} }}</label>
  <p-dropdown
    (ngModelChange)="updateSensorName($event)"
    *ngIf="loaded"
    [autoDisplayFirst]="false"
    [filter]="true"
    [ngModel]="sensorName"
    [options]="measurements"
    [required]="_mode === 'sendCommand'"
    [showClear]="true"
    appendTo="body" filterBy="name"
    inputId="sensor-name" optionLabel="name"
    optionValue="name"
    styleClass="w-full"
  >
  </p-dropdown>
  <p-skeleton *ngIf="!loaded" height="33px" styleClass="w-full"></p-skeleton>
</div>
<div class="flex flex-column">
  <label class="mb-2">{{ 'misc.paramLabel' | transloco: {paramName: 'sensorValue'} }}</label>
  <p-inputNumber
    (ngModelChange)="updateSensorValue($event)"
    *ngIf="loaded"
    [maxFractionDigits]=9
    [minFractionDigits]=1
    [ngModel]="sensorValue"
    [required]="_mode === 'sendCommand'"
    [showButtons]="true"
    [step]=0.1
    [useGrouping]="false"
    inputId="sensor-value"
    locale="en-US"
    mode="decimal"
    styleClass="w-full p-fluid"
  >
  </p-inputNumber>
  <p-skeleton *ngIf="!loaded" height="33px" styleClass="w-full"></p-skeleton>
</div>
